const vowels = {
	a: 'a',
	e: 'e',
	i: 'i',
	o: 'o',
	u: 'u',
	y: 'y',
};

export const tags = {
	// tags
	...vowels,
	emailConfirmed: 'email.confirmed',
	discordConnected: 'ai.discord.connected',
	customer: 'customer', // added after first purchase in the app
	subscriber: 'subscriber', // ever had a subscription
	subscription: 'subscription',
	// experiments
	newPaywall: 'ai.subscription.paywall',
	emailConfirmRequired: 'ai.confirmation.wall',
	test: 'test',
	neuronsWithPricePer100: 'ai.web.price.per.100.neurons.paywall.exp',
	animatedGrid: 'ai.animated.grid.exp',
	suggestedTexts: 'ai.suggestions',
	topicsHidden: 'ai.web.gifts.exp',
	liveopsGlobalControl: 'ai.web.liveopsglobal.control',
};
